'use strict'

import Site from './site'

export default class Section {
    // constructor() {
        
    // }

    static fromData(data) {
        if (!data) {
            return null
        }

        let section = new Section()
        section._id = data.section_id || -1
        section._name = data.section_name || null
        section._part = data.section_part || -1
        section._dimension = data.section_dimension || 0
        section._sites = {}

        return section
    }

    get id () {
        return this._id
    }

    get name () {
        return this._name
    }

    get part () {
        return this._part
    }

    get dimension () {
        return this._dimension
    }

    get sites () {
        return this._sites
    }

    addSite (site) {
        if(!site) {
            return
        }
        this._sites[site.id] = site
    }

    addSiteFromData (siteData) {
        this.addSite(Site.fromData(siteData))
    }

}



// WEBPACK FOOTER //
// ./src/models/section.js